module.exports = __webpack_public_path__ + "static/media/icons-20.51ec31f3.ttf";